import React from 'react';
import HelpItem from './HelpItem';

const HelpGroup = (props) => {
  const { data } = props;
  const helpItems = data ? data.helpItems.map((item, i) => <HelpItem key={i} data={item} />) : null;

  return (
    <div id="stories">
      <h1 className="heading heading--1">{ data.name }</h1>
      <ul id="filter-list-1" className="js-filter-list items items--list">
        { helpItems }
      </ul>
    </div>
  );
};

export default HelpGroup;
